import React, { FC, useEffect } from 'react';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { PropertyList, PropertyListItemButton } from 'components/property-settings/property-shared-styles';

type BtnListTypeSettingProps = {
    setting: string[];
    propertyName: string;
    settingValue: string;
    handlePropertySelection: (propertyName: string, settingValue: string) => void;
};

const BtnListTypeSetting: FC<BtnListTypeSettingProps> = ({
    propertyName,
    settingValue,
    setting,
    handlePropertySelection,
}: BtnListTypeSettingProps) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [selectedSetting, setSelectedSetting] = React.useState('');

    useEffect(() => {
        setSelectedSetting(settingValue || '');
    }, [settingValue]);

    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, settingValue: string) => {
        setSelectedSetting(settingValue);
        handlePropertySelection(propertyName, settingValue);
    };

    return (
        <PropertyList>
            {setting.map((elem) => {
                return (
                    <PropertyListItemButton
                        key={elem}
                        selected={selectedSetting === elem}
                        onClick={(event) => handleListItemClick(event, elem)}
                    >
                        <ListItemText primary={translate(elem)} primaryTypographyProps={{ fontSize: '13px' }} />
                    </PropertyListItemButton>
                );
            })}
        </PropertyList>
    );
};

export default BtnListTypeSetting;
